export function isMobile() {
  try {
    const ua = navigator.userAgent;
    const isWindowsPhone = /(?:Windows Phone)/.test(ua);
    const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    const isIOS = /(?:iPhone|iPad|iPod)/.test(ua);
    
    // 增強的平板檢測 - 特別針對 Samsung Tab 系列
    const isTablet = /(?:iPad|PlayBook|Tablet)/.test(ua) || 
                     (isAndroid && !/(?:Mobile)/.test(ua)) || 
                     (isFireFox && /(?:Tablet)/.test(ua)) ||
                     /(?:Galaxy Tab|SM-T|GT-P|GT-N|SM-P)/.test(ua) ||
                     /(?:Tab S|Galaxy Tab S)/.test(ua) ||  // Samsung Tab S 系列
                     /(?:SM-X)/.test(ua);  // Samsung Tab S10/S10+ 型號
    
    // 手機檢測
    const isPhone = (/(?:iPhone)/.test(ua) || 
                    (isAndroid && /(?:Mobile)/.test(ua)) ||
                    isWindowsPhone) && !isTablet;
    
    // 觸控支援檢測
    const hasTouchSupport = 'ontouchstart' in window || 
                           navigator.maxTouchPoints > 0 || 
                           navigator.msMaxTouchPoints > 0;
    
    // 螢幕比例檢測 (平板通常是 4:3 或 16:10，電腦通常是 16:9 或更寬)
    const screenRatio = Math.max(window.screen.width, window.screen.height) / 
                       Math.min(window.screen.width, window.screen.height);
    const isTabletRatio = screenRatio <= 1.8; // 平板比例通常小於 1.8
    
    // 電腦檢測 - 改進邏輯
    const isPc = !isPhone && !isAndroid && !isSymbian && !isTablet && !isIOS &&
                 !/(?:Mobile|Tablet)/.test(ua) && 
                 !hasTouchSupport && // 電腦通常沒有觸控
                 screenRatio > 1.5; // 電腦螢幕通常比例較寬
    
    // 優先檢查已知的行動作業系統
    if (isIOS || isAndroid || isWindowsPhone || isSymbian) {
      return true;
    }
    
    // 檢查是否為平板 (包含大螢幕平板)
    if (isTablet) {
      return true;
    }
    
    // 檢查是否有觸控支援且螢幕比例像平板
    if (hasTouchSupport && isTabletRatio) {
      return true;
    }
    
    // 檢查是否有觸控支援但螢幕不是超大 (避免觸控螢幕電腦被誤判)
    if (hasTouchSupport && window.screen.width < 1920 && window.screen.height < 1920) {
      return true;
    }
    
    return !isPc; // 返回非電腦裝置
  } catch (error) {
    console.error('isMobile 偵測錯誤:', error);
    // 錯誤時回傳 false，視為電腦
    return false;
  }
}

export function getDeviceInfo() {
  try {
    const ua = navigator.userAgent;
    const isWindowsPhone = /(?:Windows Phone)/.test(ua);
    const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    const isIOS = /(?:iPhone|iPad|iPod)/.test(ua);
    
    // 增強的平板檢測 - 包含 Samsung Tab S 系列
    const isTablet = /(?:iPad|PlayBook|Tablet)/.test(ua) || 
                     (isAndroid && !/(?:Mobile)/.test(ua)) || 
                     (isFireFox && /(?:Tablet)/.test(ua)) ||
                     /(?:Galaxy Tab|SM-T|GT-P|GT-N|SM-P)/.test(ua) ||
                     /(?:Tab S|Galaxy Tab S)/.test(ua) ||
                     /(?:SM-X)/.test(ua);
    
    // 特殊平板型號檢測
    const isSamsungTab = /(?:Galaxy Tab|SM-T|SM-X|Tab S)/.test(ua);
    const isIPad = /(?:iPad)/.test(ua);
    
    const isPhone = (/(?:iPhone)/.test(ua) || 
                    (isAndroid && /(?:Mobile)/.test(ua)) ||
                    isWindowsPhone) && !isTablet;
    
    // 觸控和螢幕資訊
    const hasTouchSupport = 'ontouchstart' in window || 
                           navigator.maxTouchPoints > 0 || 
                           navigator.msMaxTouchPoints > 0;
    
    const screenRatio = Math.max(window.screen.width, window.screen.height) / 
                       Math.min(window.screen.width, window.screen.height);
    
    const isPc = !isPhone && !isAndroid && !isSymbian && !isTablet && !isIOS &&
                 !/(?:Mobile|Tablet)/.test(ua) && 
                 !hasTouchSupport && 
                 screenRatio > 1.5;
    
    // 額外的裝置資訊
    const screenInfo = {
      width: window.screen.width,
      height: window.screen.height,
      availWidth: window.screen.availWidth,
      availHeight: window.screen.availHeight,
      orientation: window.screen.orientation ? window.screen.orientation.angle : window.orientation || 0,
      ratio: screenRatio,
      isTabletRatio: screenRatio <= 1.8
    };
    
    const touchInfo = {
      hasTouchSupport,
      maxTouchPoints: navigator.maxTouchPoints || 0,
      msMaxTouchPoints: navigator.msMaxTouchPoints || 0
    };
    
    // 詳細的裝置分類
    const deviceClassification = {
      isSamsungTab,
      isIPad,
      isLargeTablet: isTablet && (window.screen.width >= 1024 || window.screen.height >= 1024),
      isSmallTablet: isTablet && window.screen.width < 1024 && window.screen.height < 1024
    };
    
    const deviceInfo = {
      isTablet,
      isPhone,
      isAndroid,
      isIOS,
      isPc,
      isWindowsPhone,
      isSymbian,
      isMobile: !isPc,
      userAgent: ua,
      screen: screenInfo,
      touch: touchInfo,
      classification: deviceClassification,
      timestamp: new Date().toISOString()
    };
    
    return deviceInfo;
  } catch (error) {
    console.error('getDeviceInfo 錯誤:', error);
    return {
      isTablet: false,
      isPhone: false,
      isAndroid: false,
      isIOS: false,
      isPc: true,
      isWindowsPhone: false,
      isSymbian: false,
      isMobile: false,
      userAgent: navigator.userAgent || '',
      screen: {},
      touch: {},
      timestamp: new Date().toISOString(),
      error: error.message
    };
  }
}

// 新增持續監控功能
export class DeviceMonitor {
  constructor() {
    this.callbacks = [];
    this.lastDeviceInfo = null;
    this.checkInterval = null;
  }
  
  // 開始監控
  startMonitoring(interval = 2000) {
    this.lastDeviceInfo = getDeviceInfo();
    
    this.checkInterval = setInterval(() => {
      const currentDeviceInfo = getDeviceInfo();
      
      // 檢查關鍵屬性是否改變
      if (this.hasDeviceChanged(this.lastDeviceInfo, currentDeviceInfo)) {
        this.notifyCallbacks(currentDeviceInfo, this.lastDeviceInfo);
        this.lastDeviceInfo = currentDeviceInfo;
      }
    }, interval);
  }
  
  // 停止監控
  stopMonitoring() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }
  
  // 檢查裝置是否改變
  hasDeviceChanged(oldInfo, newInfo) {
    if (!oldInfo || !newInfo) return true;
    
    const keysToCheck = ['isMobile', 'isTablet', 'isPhone', 'isPc'];
    return keysToCheck.some(key => oldInfo[key] !== newInfo[key]) ||
           oldInfo.screen.orientation !== newInfo.screen.orientation;
  }
  
  // 註冊回調函數
  onDeviceChange(callback) {
    this.callbacks.push(callback);
    return () => {
      this.callbacks = this.callbacks.filter(cb => cb !== callback);
    };
  }
  
  // 通知回調函數
  notifyCallbacks(newInfo, oldInfo) {
    this.callbacks.forEach(callback => {
      try {
        callback(newInfo, oldInfo);
      } catch (error) {
        console.error('DeviceMonitor callback 錯誤:', error);
      }
    });
  }
}

// 建立全域監控實例
export const globalDeviceMonitor = new DeviceMonitor();